<template>
  <nav class="bg-base-100 dark:bg-base-200 border-b">
    <div class="flex px-2 py-3 justify-between items-center" :class="{ 'container-lg': !isAuthenticated }">
      <div class="flex gap-3">
        <div class="flex flex-shrink-0 items-center">
          <router-link :to="routeManager.homePath()" class="tmi-logo h-10" :class="isAuthenticated ? 'aspect-square lg:aspect-[4/1] w-10 lg:w-auto bg-cover lg:bg-contain' : 'tmi-logo h-10 w-40 bg-contain'"></router-link>
        </div>
        <div class="hidden lg:flex lg:items-center">
          <router-link v-if="showDashboard" :to="routeManager.homePath()" class="navbar-btn">Dashboard</router-link>

          <!-- PRODUCTS -->
          <details v-if="showProductsMenuItem" id="products-menu" @mouseenter="showMenuOnFocus" @mouseleave="hideMenuOnBlur" class="dropdown dropdown-hover">
            <summary class="navbar-btn">Products</summary>
            <ul class="menu dropdown-content w-72" @click="hideMenuOnBlur">

              <!-- My Subscriptions -->
              <template v-if="showProductSubscriptions">
                <li class="menu-title text-jade pl-2 pb-0 uppercase">My Subscriptions</li>
                <li v-for="product in subscribedProducts" :key="product.slug">
                  <router-link :to="routeManager.productRouteBySlug( product.slug )">
                    <img loading='lazy' v-if="product.favicon" :src="product.favicon" class="rounded-lg w-6 h-6" alt="Product Logo">
                    <span> {{ product.name }}</span>
                  </router-link>
                </li>
              </template>

              <!-- Available Subscriptions -->
              <template v-if="showProductBrochures">
                <li class="menu-title text-jade pl-2 pb-0 uppercase">Available Subscriptions</li>
                <li v-for="product in productBrochures" :key="product.slug">
                  <router-link :to="routeManager.productRouteBySlug( product.slug )">
                    <img loading='lazy' v-if="product.favicon" :src="product.favicon" class="rounded-lg w-6 h-6" alt="Product Logo">
                    <span> {{ product.name }}</span>
                  </router-link>
                </li>
              </template>

            </ul>
          </details>

          <!-- ALERTS -->
          <details v-if="showAlertsMenuItem" id="alerts-menu" @mouseenter="showMenuOnFocus" @mouseleave="hideMenuOnBlur" class="dropdown dropdown-hover">
            <summary class="navbar-btn">Alerts</summary>
            <ul class="menu dropdown-content" @click="hideMenuOnBlur">
              <li v-if="showSectorAlertsMenuOption"><router-link :to="routeManager.sectorAlertsPath()">Sector Alerts</router-link></li>
              <li v-if="showTradeAlertsMenuOption"><router-link :to="routeManager.tradeAlertsPath()">Trade Alerts</router-link></li>
            </ul>
          </details>

          <!-- TOOLS -->
          <details v-if="showToolsMenuItem" id="tools-menu" @mouseenter="showMenuOnFocus" @mouseleave="hideMenuOnBlur" class="dropdown dropdown-hover">

            <summary class="navbar-btn">Tools</summary>
            <ul class="menu dropdown-content" @click="hideMenuOnBlur">
              <template v-if="showIndicatorsSection">
                <li class="menu-title text-jade pl-2 pb-0 uppercase">
                  Indicators</li>
                <li v-if="showSectorBpiMenuOption">
                  <router-link :to="routeManager.sectorBullishPercentIndicesPath()">
                    All Sector BPIs
                  </router-link>
                </li>
                <li>
                  <router-link :to="routeManager.nyseBullishPercentIndexPath()">
                    NYSE BPI
                  </router-link>
                </li>
                <li v-if="showRelativeStrengthMatrixMenuOption">
                  <router-link :to="routeManager.relativeStrengthMatrixPath()">
                    RS Matrix
                  </router-link>
                </li>
                <li v-if="showMajorIndexBreadthMenuOption">
                  <router-link :to="routeManager.majorIndexBreadthPath()">
                    Major Index Breadth
                  </router-link>
                </li>
              </template>
              <template v-if="showReferenceToolsSection">
                <li class="menu-title text-jade pl-2 pb-0 uppercase">
                  Reference Tools</li>
                <li v-if="showEtfListingMenuOption">
                  <router-link :to="routeManager.etfListingPath()">
                    ETF Listing by Sector
                  </router-link>
                </li>
                <li v-if="showSectorTreeMenuOption">
                  <router-link :to="routeManager.sectorTreePath()">
                    Sector Tree
                  </router-link>
                </li>
                <li v-if="showSectorsMenuOption">
                  <router-link :to="routeManager.sectorListingPath()">
                    Sectors
                  </router-link>
                </li>
              </template>
              <template v-if="showPortfolioToolsSection">
                <li class="menu-title text-jade pl-2 pb-0 uppercase">
                  Portfolio Tools</li>
                <li v-if="showPortfolioBuilderMenuOption">
                  <router-link :to="routeManager.portfolioBuilderPath()">
                    Portfolio Builder
                  </router-link>
                </li>
                <!--                <li v-if="showOptionsCalculatorMenuOption">-->
                <!--                  <router-link :to="routeManager.optionsCalculatorPath()">-->
                <!--                    Options Calculator-->
                <!--                  </router-link>-->
                <!--                </li>-->
                <li v-if="showPositionSizeCalculatorMenuOption">
                  <router-link :to="routeManager.positionSizeCalculatorPath()">
                    Position Size Calculator
                  </router-link>
                </li>
                <li v-if="showSpreadCalculatorMenuOption">
                  <router-link :to="routeManager.spreadCalculatorPath()">
                    Spread Calculators
                  </router-link>
                </li>
              </template>
            </ul>
          </details>

          <!-- LEARNING -->
          <router-link v-if="!isAuthenticated" :to="routeManager.articleSearchPath()" class="navbar-btn">Articles</router-link>
          <details v-else-if="showLearningMenuItem" id="learning-menu" @mouseenter="showMenuOnFocus" @mouseleave="hideMenuOnBlur" class="dropdown dropdown-hover">
            <summary class="navbar-btn">Learning</summary>
            <ul class="menu dropdown-content" @click="hideMenuOnBlur">
              <li><router-link :to="routeManager.articleSearchPath()">Articles</router-link></li>
              <li v-if="showBonusReportOption">
                <router-link :to="routeManager.bonusReportsSearchPath()">Bonus Reports</router-link>
              </li>
              <li v-if="showCoursesMenuOption">
                <router-link :to="routeManager.coursesPath()">Courses</router-link>
              </li>
              <li v-if="showWebinarsMenuOption">
                <router-link :to="routeManager.webinarSearchPath()">Webinars</router-link>
              </li>
            </ul>
          </details>

          <!-- MEDIA -->
          <router-link :to="routeManager.mediaPath()" class="navbar-btn">Media</router-link>

          <!-- ABOUT US -->
          <router-link v-if="!isAuthenticated" :to="aboutUsPath" class="navbar-btn">About</router-link>

          <!-- CONTACT US -->
          <router-link v-if="!isAuthenticated" :to="contactUsPath" class="navbar-btn">Contact</router-link>
        </div>
      </div>
      <div v-if="showMainSearch" class="flex flex-1 items-center justify-center px-2 lg:justify-end">
        <Search :stock-click-handler="navigateToSecurityDetails"
          :etf-click-handler="navigateToSecurityDetails"
          :sector-click-handler="navigateToSectorDetails"
          class="w-full max-w-lg lg:max-w-xs" />
      </div>
      <div class="flex-c">
        <div v-if="!isAuthenticated">
          <div class="flex gap-2">
            <router-link class="lg:hidden btn btn-sm btn-primary uppercase" :to="routeManager.signUpPath()">
              Sign Up
            </router-link>
            <router-link class="lg:hidden btn btn-sm btn-primary btn-outline uppercase" :to="routeManager.signInPath()">
              Log In
            </router-link>
          </div>
        </div>
        <div @click="showMobileMenu = !showMobileMenu" class="mx-4 lg:hidden">
          <i class="pi" :class="showMobileMenu ? 'pi-times' : 'pi-bars'"></i>
        </div>
      </div>
      <div class="hidden lg:flex items-center">
        <template v-if="isAuthenticated">
          <UserPanel />
        </template>
        <template v-else>
          <div class="flex gap-2">
            <router-link class="btn btn-sm btn-primary no-underline uppercase" :to="routeManager.signUpPath()">
              Sign Up
            </router-link>
            <router-link class="btn btn-sm btn-primary btn-outline no-underline uppercase" :to="routeManager.signInPath()">
              Log In
            </router-link>
          </div>
        </template>
        <DarkModeToggle />
      </div>
    </div>

    <!-- Mobile menu dropdown -->
    <div v-if="showMobileMenu" class="lg:hidden shadow-inner" id="mobile-menu">
      <ul class="menu menu-lg lg:hidden">
        <li v-if="showDashboard">
          <router-link :to="routeManager.homePath()" class="font-bold">Dashboard</router-link>
        </li>
        <li v-if="showProductsMenuItem">
          <details>
            <summary class="font-bold">Products</summary>
            <ul>
              <template v-if="showProductSubscriptions">
                <li class="menu-title text-jade pl-2 pb-0 uppercase text-lg">My Subscriptions</li>
                <li v-for="product in subscribedProducts" :key="product.slug">
                  <router-link :to="routeManager.productRouteBySlug( product.slug )">
                    <img loading='lazy' v-if="product.favicon" :src="product.favicon" class="rounded-lg w-6 h-6" alt="Product Logo">
                    <span> {{ product.name }}</span>
                  </router-link>
                </li>
              </template>
              <template v-if="showProductBrochures">
                <li v-for="product in productBrochures" :key="product.slug">
                  <router-link :to="routeManager.productRouteBySlug( product.slug )">
                    <img loading='lazy' v-if="product.favicon" :src="product.favicon" class="rounded-lg w-6 h-6" alt="Product Logo">
                    <span> {{ product.name }}</span>
                  </router-link>
                </li>
              </template>
            </ul>
          </details>
        </li>
        <li v-if="showAlertsMenuItem">
          <details>
            <summary class="font-bold">Alerts</summary>
            <ul>
              <li v-if="showSectorAlertsMenuOption"><router-link :to="routeManager.sectorAlertsPath()">Sector Alerts</router-link></li>
              <li v-if="showTradeAlertsMenuOption"><router-link :to="routeManager.tradeAlertsPath()">Trade Alerts</router-link></li>
            </ul>
          </details>
        </li>
        <li v-if="showToolsMenuItem">
          <details>
            <summary class="font-bold">Tools</summary>
            <ul>
              <template v-if="showIndicatorsSection">
                <li class="menu-title text-jade pl-2 pb-0 uppercase text-lg">
                  Indicators</li>
                <li v-if="showNyseBpiMenuOption">
                  <router-link :to="routeManager.sectorBullishPercentIndicesPath()">
                    All Sector BPIs
                  </router-link>
                </li>
                <li>
                  <router-link :to="routeManager.nyseBullishPercentIndexPath()">
                    NYSE BPI
                  </router-link>
                </li>
                <li v-if="showRelativeStrengthMatrixMenuOption">
                  <router-link :to="routeManager.relativeStrengthMatrixPath()">
                    RS Matrix
                  </router-link>
                </li>
                <li v-if="showMajorIndexBreadthMenuOption">
                  <router-link :to="routeManager.majorIndexBreadthPath()">
                    Major Index Breadth
                  </router-link>
                </li>
              </template>
              <template v-if="showReferenceToolsSection">
                <li class="menu-title text-jade pl-2 pb-0 uppercase text-lg">
                  Reference Tools</li>
                <li v-if="showEtfListingMenuOption">
                  <router-link :to="routeManager.etfListingPath()">
                    ETF Listing by Sector
                  </router-link>
                </li>
                <li v-if="showSectorTreeMenuOption">
                  <router-link :to="routeManager.sectorTreePath()">
                    Sector Tree
                  </router-link>
                </li>
                <li v-if="showSectorsMenuOption">
                  <router-link :to="routeManager.sectorListingPath()">
                    Sectors
                  </router-link>
                </li>
              </template>
              <template v-if="showPortfolioToolsSection">
                <li class="menu-title text-jade pl-2 pb-0 uppercase text-lg">
                  Portfolio Tools</li>
                <li v-if="showPortfolioBuilderMenuOption">
                  <router-link :to="routeManager.portfolioBuilderPath()">
                    Portfolio Builder
                  </router-link>
                </li>
                <!--              <li v-if="showOptionsCalculatorMenuOption">-->
                <!--                <router-link :to="routeManager.optionsCalculatorPath()">-->
                <!--                  Options Calculator-->
                <!--                </router-link>-->
                <!--              </li>-->
                <li v-if="showPositionSizeCalculatorMenuOption">
                  <router-link :to="routeManager.positionSizeCalculatorPath()">
                    Position Size Calculator
                  </router-link>
                </li>
                <li v-if="showSpreadCalculatorMenuOption">
                  <router-link :to="routeManager.spreadCalculatorPath()">
                    Spread Calculators
                  </router-link>
                </li>
              </template>
            </ul>
          </details>
        </li>
        <li v-if="!isAuthenticated">
          <router-link :to="routeManager.articleSearchPath()" class="font-bold">Articles</router-link>
        </li>
        <li v-else-if="showLearningMenuItem">
          <details>
            <summary class="font-bold">Learning</summary>
            <ul>
              <li><router-link :to="routeManager.articleSearchPath()">Articles</router-link></li>
              <li v-if="showBonusReportOption">
                <router-link :to="routeManager.bonusReportsSearchPath()">Bonus Reports</router-link>
              </li>
              <li v-if="showCoursesMenuOption">
                <router-link :to="routeManager.coursesPath()">Courses</router-link>
              </li>
              <li v-if="showWebinarsMenuOption">
                <router-link :to="routeManager.webinarSearchPath()">Webinars</router-link>
              </li>
            </ul>
          </details>
        </li>
        <li>
          <router-link :to="routeManager.mediaPath()" class="font-bold">Media</router-link>
        </li>
        <template v-if="isAuthenticated">
          <hr class="mx-5 my-2">
          <li>
            <UserPanel />
          </li>
        </template>
        <template v-else-if="!isAuthenticated">
          <li>
            <router-link :to="aboutUsPath" class="font-bold">About</router-link>
          </li>
          <li>
            <router-link :to="contactUsPath" class="font-bold">Contact</router-link>
          </li>
        </template>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { Router, useRouter } from "vue-router";

import DarkModeToggle from '@/components/layout/DarkModeToggle.vue';
import Search from '@/components/SearchField.vue';
import UserPanel from '@/components/layout/UserPanel.vue';

import routeManager from "@/router/route-manager";
import type { Product } from "@/types/entities";

import { useAuthStore } from "@/stores/Auth";
import { useProductsStore } from "@/stores/Products";

import { useMenuPermissions } from "@/composables/menu-permissions";

const { isAuthenticated } = storeToRefs( useAuthStore() );
const productsStore = useProductsStore();
const { availableProducts, subscribedProducts } = storeToRefs( productsStore );

const {
  showBonusReportOption,
  showCoursesMenuOption,
  showDashboard,
  showEtfListingMenuOption,
  // showEquityCalculatorMenuOption,
  showLearningMenuItem,
  showMainSearch,
  showMajorIndexBreadthMenuOption,
  showNyseBpiMenuOption,
  // showOptionsCalculatorMenuOption,
  showPortfolioBuilderMenuOption,
  showPositionSizeCalculatorMenuOption,
  showRelativeStrengthMatrixMenuOption,
  showSectorAlertsMenuOption,
  showSectorBpiMenuOption,
  showSectorsMenuOption,
  showSectorTreeMenuOption,
  showSpreadCalculatorMenuOption,
  showToolsMenuItem,
  showTradeAlertsMenuOption,
  showWebinarsMenuOption,
  showProductsMenuItem,
  showAlertsMenuItem,
  showIndicatorsSection,
  showPortfolioToolsSection,
  showReferenceToolsSection
} = useMenuPermissions();

const router: Router = useRouter();

const aboutUsPath = ref< string >( routeManager.aboutUsPath() );
const contactUsPath = ref< string >( routeManager.contactUsPath() );

const hasAvailableProducts = computed< boolean >( () => availableProducts.value?.length > 0 );
const hasSubscriptions = computed< boolean >( () => subscribedProducts.value?.length > 0 );

const showProductSubscriptions = computed< boolean >( () => isAuthenticated.value && hasSubscriptions.value );
const showProductBrochures = computed< boolean >( () => !isAuthenticated.value || hasAvailableProducts.value );
const productBrochures = computed< Product[] >( () => {
  let products: Product[] = [];
  if ( isAuthenticated.value ) {
      availableProducts.value.forEach( ( product: Product ) => products.push( product ) );
  } else {
      products = [ ...productsStore.displayableProducts ];
  }

  return products;
} );

const showMobileMenu = ref( false );
router.beforeEach( () => {
  showMobileMenu.value = false;
} );

function hideMenuOnBlur( event: MouseEvent ) {
  if ( event.target ) {
      ( event.target as Element ).removeAttribute( "open" );
  }
}

function showMenuOnFocus( event: Event ) {
  if ( event.target ) {
      ( event.target as Element ).setAttribute( "open", "" );
  }
}

async function navigateToSecurityDetails( ticker: string ) {
  await router.push( routeManager.buildSecurityPath( ticker ) );
}

async function navigateToSectorDetails( symbol: string ) {
  await router.push( routeManager.sectorDetailsRouteBySymbol( symbol ) );
}
</script>

<style>
a.tmi-logo {
  background-image: url("/img/logos/logo-green.svg");
  background-repeat: no-repeat;
}

[data-theme="dark"] a.tmi-logo {
  background-image: url("/img/logos/logo-white.svg")
}
</style>
